import http from "@/axios/http-common";
import ErrorAlert from "@/utility/ErrorAlert";

export interface KegiatanIgdPeriode {
  tahun: number;
  bulan: number;
  label: string;
  jumlah_hari: number;
}

export interface KegiatanIgdMeta {
  total_kunjungan: number;
  tanpa_disposisi: number;
  tanpa_kasus: number;
}

export interface KegiatanIgdResponse {
  periode: KegiatanIgdPeriode;
  kategori: Record<string, string>;
  disposisi: Record<string, string>;
  disposisi_manual: string[];
  rme: Record<string, number>;
  koreksi: Record<string, number>;
  nilai: Record<string, number>;
  catatan: string | null;
  meta: KegiatanIgdMeta;
}

export interface KegiatanIgdPeriodeParam {
  tahun: number;
  bulan: number;
}

export function selKey(
  kategori: string,
  disposisi: string,
  hari: number
): string {
  return `${kategori}.${disposisi}.${hari}`;
}

async function get(p: KegiatanIgdPeriodeParam): Promise<KegiatanIgdResponse> {
  const res = await http
    .getDataParam(`/laporan/kegiatan-igd`, { params: p })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return res.data.data;
}

async function save(
  p: KegiatanIgdPeriodeParam,
  koreksi: Record<string, number>,
  catatan: string | null
): Promise<KegiatanIgdResponse> {
  const res = await http
    .putData(`/laporan/kegiatan-igd`, { ...p, koreksi, catatan })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return res.data.data;
}

async function openPdf(p: KegiatanIgdPeriodeParam): Promise<void> {
  const res = await http
    .getDataParam(`/laporan/kegiatan-igd/pdf`, {
      params: p,
      responseType: "blob"
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  const url = URL.createObjectURL(
    new Blob([res.data], { type: "application/pdf" })
  );
  window.open(url, "_blank");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export default { get, save, openPdf, selKey };

